var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "doctor-tasks"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.getParams.f.state === 'scheduled') ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "data-testid": "doctor-tasks-filter-scheduled"
    }
  }, [_vm._v("nevyřízeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "doctor-tasks-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectScheduledState()
      }
    }
  }, [_vm._v("nevyřízeno")]), _vm._v(" "), (_vm.getParams.f.state === 'completed') ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "data-testid": "doctor-tasks-filter-completed"
    }
  }, [_vm._v("splněno")]) : _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "doctor-tasks-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectCompletedState()
      }
    }
  }, [_vm._v("splněno")]), _vm._v(" "), (_vm.getParams.f.state === 'canceled') ? _c('button', {
    staticClass: "btn btn-sm btn-success"
  }, [_vm._v("zrušeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    on: {
      "click": function($event) {
        _vm.selectCanceledState()
      }
    }
  }, [_vm._v("zrušeno")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 text-center"
  }, [(_vm.doctors.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plannedFor),
      expression: "plannedFor"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "doctor-tasks-doctor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.plannedFor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("všichni doktoři")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    on: {
      "click": function($event) {
        _vm.getDoctorsDayVisits()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), (_vm.listData.length > 0) ? _c('div', {
    staticClass: "card-body pl-0 pr-0"
  }, [_vm._l((_vm.listData), function(visit, index) {
    return [_c('div', {
      staticClass: "row ml-0 mr-0 card_row",
      attrs: {
        "data-testid": 'doctor-task-' + visit.id
      }
    }, [_c('div', {
      staticClass: "col-sm-auto pl-2 pr-0 pt-2"
    }, [_c('i', {
      staticClass: "fa fa-2x fa-exclamation text-danger text_blink",
      class: visit.acute === true ? '' : 'invisible',
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-auto pl-0 pr-0"
    }, [_c('visit-task-change-state', {
      attrs: {
        "actual-state": visit.state,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id
      },
      on: {
        "update": _vm.getDoctorsDayVisits
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col pl-0 pr-0"
    }, [_c('div', {
      staticClass: "row m-0"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": {
          name: 'ShowClient',
          params: {
            clientid: visit.client.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-address-card-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(visit.client.first_name) + " " + _vm._s(visit.client.last_name))])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b>',
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                                content: 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b>',\n                                placement: 'bottom-center',\n                                classes: ['info']}"
      }]
    }, [_vm._v("\n                                " + _vm._s(visit.planned_at) + "\n                            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "row m-0"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [
      [_c('button', {
        staticClass: "btn btn-sm btn_extra_small btn-primary",
        attrs: {
          "data-testid": 'doctor-task-detail-' + visit.id
        },
        on: {
          "click": function($event) {
            _vm.showHideVisitDetail(index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-info-circle",
        attrs: {
          "aria-hidden": "true"
        }
      })])], _vm._v(" "), _c('router-link', {
        attrs: {
          "to": {
            name: 'ShowVisit',
            params: {
              clientid: visit.client.id,
              visitid: visit.id
            }
          }
        }
      }, [_c('b', [_vm._v(_vm._s(visit.visit_purpose.purpose))])]), _vm._v(" "), (_vm.editingVisitId === visit.id) ? [_c('form', {
        staticClass: "form-inline",
        on: {
          "submit": function($event) {
            $event.preventDefault();
            _vm.putVisit(visit)
          }
        }
      }, [_c('label', {
        attrs: {
          "for": "note"
        }
      }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.editingVisit.note),
          expression: "editingVisit.note"
        }],
        staticClass: "form-control ml-sm-1 col-sm-10 mr-sm-2",
        attrs: {
          "type": "text",
          "aria-describedby": "noteHelp",
          "id": "note",
          "data-testid": 'doctor-task-note-' + visit.id
        },
        domProps: {
          "value": (_vm.editingVisit.note)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.editingVisit.note = $event.target.value
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "mr-sm-2",
        attrs: {
          "for": "doctor"
        }
      }, [_vm._v("K doktorovi")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.editingVisit.planned_for),
          expression: "editingVisit.planned_for"
        }],
        staticClass: "form-control mr-sm-2",
        attrs: {
          "aria-describedby": "doctorHelp",
          "id": "doctor",
          "placeholder": "vybrat doktora",
          "autofocus": "autofocus"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.editingVisit.planned_for = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          }
        }
      }, _vm._l((_vm.doctors), function(row) {
        return _c('option', {
          domProps: {
            "value": row.id
          }
        }, [_vm._v(_vm._s(row.fullname))])
      })), _vm._v(" "), _c('label', {
        staticClass: "mr-sm-2",
        attrs: {
          "for": "acute"
        }
      }, [_vm._v("\n                                        prioritní "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.editingVisit.acute),
          expression: "editingVisit.acute"
        }],
        staticClass: "form-check-input",
        attrs: {
          "type": "checkbox",
          "id": "acute"
        },
        domProps: {
          "checked": Array.isArray(_vm.editingVisit.acute) ? _vm._i(_vm.editingVisit.acute, null) > -1 : (_vm.editingVisit.acute)
        },
        on: {
          "__c": function($event) {
            var $$a = _vm.editingVisit.acute,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.editingVisit.acute = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.editingVisit.acute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.editingVisit.acute = $$c
            }
          }
        }
      })]), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
        staticClass: "btn btn-primary",
        attrs: {
          "type": "submit",
          "data-testid": 'doctor-task-save-' + visit.id
        }
      }, [_vm._v("Uložit")]) : _c('button', {
        staticClass: "btn btn-primary disabled",
        attrs: {
          "disabled": "disabled"
        }
      }, [_c('i', {
        staticClass: "fa fa-spinner fa-pulse fa-fw"
      }), _vm._v(" Ukládám")])])] : [_c('button', {
        staticClass: "btn btn-sm btn-link text-secondary",
        attrs: {
          "data-testid": 'doctor-task-edit-' + visit.id
        },
        on: {
          "click": function($event) {
            _vm.editVisit(visit, visit.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _c('i', [_vm._v("poznámka: " + _vm._s(visit.note))])]
    ], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-auto pl-0 pr-0"
    }, [_c('button', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'naplánováno pro: <b>' + visit.planned_for.fullname + '</b> <br>' + 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b><br>dne <b>' + visit.planned_at + '</b>',
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                                content: 'naplánováno pro: <b>' + visit.planned_for.fullname + '</b> <br>' + 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b><br>dne <b>' + visit.planned_at + '</b>',\n                                placement: 'bottom-center',\n                                classes: ['info']}"
      }],
      staticClass: "btn btn-primary btn_circle btn_md vertically_centered",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("\n                        " + _vm._s(visit.planned_for.monogram.toUpperCase()) + "\n                    ")])]), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), (_vm.showedVisitDetail.indexOf(index) > -1) ? _c('div', {
      staticClass: "card_row"
    }, [_c('div', {
      staticClass: "p-2"
    }, [(visit.presenting_complaint) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v(_vm._s(visit.presenting_complaint.anamnesis_type.name))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.presenting_complaint.text)
      }
    })]) : (visit.medical_report) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v("Lékařská zpráva")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.medical_report.text)
      }
    })]) : _vm._e(), _vm._v(" "), (visit.diagnosis.length > 0) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
        return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                        " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                    ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                               zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                        ")])])
        }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                               zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                        ")])])
        }) : _vm._e()]
      })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(2, true)])]]
    })], 2)])])]) : _vm._e(), _vm._v(" "), (visit.medicament.length > 0) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', _vm._l((visit.medicament), function(m) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + "\n                                              " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
    }))])])]) : _vm._e()])]) : _vm._e()]
  }), _vm._v(" "), _c('pagination-component', {
    attrs: {
      "list-pagination": _vm.listPagination
    },
    on: {
      "set-page": _vm.setPage
    }
  })], 2) : (_vm.listPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(3)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(4)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Úkoly")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-auto"
  }, [_c('span', {
    staticClass: "fa fa-2x fa-angle-right text-primary vertically_centered invisible",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (na tento den není nic naplánováno)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35a34d79","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/HomeDoctor/components/Tasks.vue
// module id = 397
// module chunks = 0